import React from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from 'react-final-form';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import { trueFalseOptions } from '../../OnboardingConstants';
import GenericTextAreaInputField from '../../../commons/form-fields/GenericTextAreaInputField';

class ConfidentialInfoInner extends React.Component {
    render() {
        const hasConfidentialInfoAccess =
            this.props.values.info?.confidentialInfo?.hasConfidentialInfo;
        return (
            <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
                <HeaderAndError label="Access to Confidential Information" />
                <GenericToggleButtonGroupField
                    name={'info.confidentialInfo.hasConfidentialInfo'}
                    inlineLabel={
                        'Do you currently, or have you at any time in the last six months, been in possession of any ' +
                        'confidential information or intellectual property of, or material non-public information ' +
                        "relating to, any entity other than the entities you list above under 'Job Information' " +
                        '("Material Non-Public Information" is defined in the Terms of Participation)?'
                    }
                    options={trueFalseOptions}
                    required
                />
                {hasConfidentialInfoAccess && (
                    <GenericTextAreaInputField
                        name={'info.confidentialInfo.description'}
                        label={
                            'Without disclosing the content of the materials in your possession,' +
                            ' please describe in general terms the nature of the information you possess,' +
                            ' including whether it may be deemed to be material non-public information.'
                        }
                        required
                        clearOnUnmount
                    />
                )}
            </div>
        );
    }
}

ConfidentialInfoInner.propTypes = {
    values: PropTypes.any,
};

const ConfidentialInfoAccessSection = (props) => (
    <FormSpy {...props} component={ConfidentialInfoInner} />
);

export { ConfidentialInfoAccessSection };
